import classNames from 'classnames';
import React from 'react';
import { green, orange } from '../../Styles/Colours';
import { LockedPadlockIcon, UnlockedPadlockIcon } from '../Icons';
import styles from './DraftPublishedChip.module.css';
export var DraftPublishedChipStatus;
(function (DraftPublishedChipStatus) {
    DraftPublishedChipStatus[DraftPublishedChipStatus["Draft"] = 0] = "Draft";
    DraftPublishedChipStatus[DraftPublishedChipStatus["Published"] = 1] = "Published";
})(DraftPublishedChipStatus || (DraftPublishedChipStatus = {}));
export var DraftPublishedChip = function (props) {
    var _a;
    var iconSize = '12';
    var isPublished = props.status === DraftPublishedChipStatus.Published;
    var padlockColour = isPublished ? green : orange;
    var rosterStatus = isPublished ? 'published' : 'draft';
    var padlock = isPublished ? (React.createElement(LockedPadlockIcon, { size: iconSize, color: padlockColour })) : (React.createElement(UnlockedPadlockIcon, { size: iconSize, color: padlockColour }));
    var padlockComponent = React.createElement("div", { className: styles.padlock }, padlock);
    var rosterStatusComponent = React.createElement("div", { className: styles.text }, rosterStatus);
    return (React.createElement("div", { className: classNames(styles.content, styles.status, (_a = {},
            _a[styles.published] = props.status === DraftPublishedChipStatus.Published,
            _a[styles.draft] = props.status === DraftPublishedChipStatus.Draft,
            _a)) },
        padlockComponent,
        rosterStatusComponent));
};
